export default __webpack_public_path__ + "static/media/onboarding-bg.4395644c.png";